import React from "react";
import "../PlanCreationModal.scss";
import { Divider, Grid, Typography } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";

const tabs = [
  "01. EXPENSES",
  "02. INCOME",
  "03. ASSETS",
  "04. INSURANCE",
  "05. TAXES",
];

const Tabs = ({ currentTab, onSelectTab }) => {
  const handleSelectTab = (tab) => () => {
    if (tab < currentTab) {
      onSelectTab(tab);
    }
  };

  return (
    <Grid container className="tabs">
      {tabs.map((tab, index) => {
        const isLastStep = index === tabs.length - 1;
        const isCurrentStep = index === currentTab;
        const isCompletedStep = index < currentTab;

        return (
          <Grid
            item
            key={tab}
            className="tab-step"
            onClick={handleSelectTab(index)}
          >
            <div
              className={`tab-step-text-wrapper ${
                isLastStep ? "tab-step-last" : ""
              }`}
            >
              <Typography
                component="span"
                className={`tab-step-text ${
                  isCurrentStep || isCompletedStep ? "highlighted-text" : ""
                }`}
              >
                {tab}
              </Typography>
              {isCurrentStep && <Divider className="tab-step-underline" />}
            </div>
            {!isLastStep && <ChevronRight className="tab-step-arrow" />}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default Tabs;
